import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Modal from '../Modal/Modal';
import { Typography, Grid, TextField, IconButton, Box, Link } from '@material-ui/core';
import loadable from "../../components/Lazy";
import { makeStyles } from '@material-ui/core/styles';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { animateScroll, scroller } from 'react-scroll';
import {connect} from 'react-redux';
import { Formik } from 'formik';
import Alert from "@material-ui/lab/Alert";
import {
    useCSVReader,
} from 'react-papaparse';

import {validateEmail, validatePhoneNumber} from "../../utils";
import {setModal} from "../../actions/app";
import LazyImage from "../App/LazyImage";

const useStyles = makeStyles((theme) => ({
    cellHighlight: {
        backgroundColor: 'purple'
    },
    root: {
        minHeight: '300px'
    },
    list: {
        maxHeight: '400px'
    },
    textFields: {
        width: '400px',
        maxWidth: '100%',
    },
    textFieldsRow: {
        marginBottom: theme.spacing(2)
    },
    listContainer: {
        maxHeight: '455px',
        overflowY: 'auto',
        marginBottom: theme.spacing(4)
    },
    deleteButton: {
        marginTop: theme.spacing(1)
    },
    zoneContainer: {
        height: '0',
        padding: 20,
        paddingBottom: '40%',
        position: 'relative',
        marginBottom: theme.spacing(4)
    },
    zone: {
        alignItems: 'center',
        borderWidth: 1,
        top: 0,
        left: 0,
        borderStyle: 'dashed',
        borderColor: theme.palette.grey[500],
        backgroundColor: theme.palette.grey[100],
        borderRadius: 20,
        flexDirection: 'column',
        display: 'flex',
        height: '100%',
        width: '100%',
        position: 'absolute',
        padding: 20,
        justifyContent: 'center',
    },
    file: {
        borderRadius: 20,
        display: 'flex',
        position: 'relative',
        zIndex: 10,
        flexDirection: 'column',
        justifyContent: 'center',
    },
    progressBar: {
        bottom: 14,
        position: 'absolute',
        width: '100%',
        paddingLeft: 10,
        paddingRight: 10,
    },
    zoneHover: {
        borderColor: 'grey',
    },
    default: {
        borderColor: 'grey',
    },
    remove: {
        height: 23,
        position: 'absolute',
        right: 6,
        top: 6,
        width: 23,
    },
    continueToReviewFileButton: {
        maxWidth: '300px',
        margin: 'auto',
        marginBottom: theme.spacing(4),
        display: 'block'
    },
    badFileAlert: {
        marginBottom: theme.spacing(3),
        width: '100%'
    },
    miniMaxAlert: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        width: '100%'
    }

}));
const Button = loadable(() => import('../../components/Button/LoadingButton'));

const ImportRecipientsFromCsvModal = ({
    onRecipientImport,
    importRecipientInit = "",
    setModal,
    setStoredRecipients,
    storedRecipients,
    cartCount
}) => {
    const { CSVReader } = useCSVReader();
    const theme = useTheme();
    const classes = useStyles();
    const [step, setStep] = React.useState(1);
    const [scrollToBottom, setScrollToBottom] = React.useState(false);
    const [uploadNewFile, setUploadNewFile] = React.useState(false);
    const [accepted, setAccepted] = React.useState(false);
    const [initialRecipients, setInitialRecipients] = React.useState([]);
    const lastInputRef = React.useRef();
    const [zoneHover, setZoneHover] = React.useState(false);

    const handleUploadNewFile = ({e, onClick}) => {
        onClick(e);
        setUploadNewFile(true);
        setStep(1);
    };

    React.useEffect(() => {
        if (uploadNewFile) {
            document.getElementById('browse-file-button').click();
        }
        setUploadNewFile(false);
    }, [uploadNewFile])

    const handleContinue = () => {
        setStep(2);
    }

    const handleImport = (values) => {
        const sms = [];
        const email = [];
        for (let i = values.recipients.length-1; i >= 0; i--) {
            if (validatePhoneNumber(values.recipients[i])) {
                sms.push(values.recipients[i].replace(/\D/g, ''));
            }
            if (validateEmail(values.recipients[i])) {
                email.push(values.recipients[i]);
            }
        }
        setStep(1);
        onRecipientImport({recipients: {sms, email}});
        setStoredRecipients(values.recipients);
        setModal('');
    }

    React.useEffect(() => {
        if (scrollToBottom) {
            animateScroll.scrollToBottom({
                containerId: 'list-container',
                duration: 200
            });
            setScrollToBottom(false);
            lastInputRef.current.focus();
        }
    }, [scrollToBottom]);

    React.useEffect(() => {
        if (importRecipientInit === 'upload') {
            if (document.getElementById('browse-file-button')) {
                document.getElementById('browse-file-button').click();
            }
        }
        if (importRecipientInit === 'edit') {
            setStep(2);
            setInitialRecipients(storedRecipients);
        }
        if (importRecipientInit === 'add-another') {
            setStep(2);
            const theseRecipients = storedRecipients;
            theseRecipients.push('');
            setInitialRecipients([
                ...theseRecipients
            ]);
            setScrollToBottom(true);
        }
        // eslint-disable-next-line
    }, [importRecipientInit]);

    return (
        <>
        <Modal
            maxWidth="md"
            id={`import-recipients-from-csv`}
            title={<>Import from <Box component="span" color="secondary">CSV</Box> </>}
        >
            <Grid className={classes.root} container spacing={2} style={{marginTop: theme.spacing(2)}}>

                <Grid item xs={12}>

                    <Formik
                        enableReinitialize={false}
                        validateOnMount={false}
                        validateOnChange={false}
                        validateOnBlur={true}
                        initialValues={{
                            recipients: initialRecipients,
                        }}
                        validate={values => {
                            let recipientsInvalid = {};

                            for (let i = values.recipients.length-1; i >= 0; i--) {
                                if (!validatePhoneNumber(values.recipients[i]) && !validateEmail(values.recipients[i])) {
                                    recipientsInvalid[i] = 'Please enter a valid email address or phone number';
                                }
                            }

                            if (Object.keys(recipientsInvalid).length > 0) {
                                scroller.scrollTo(`import-recipients-modal-text-field-${Object.keys(recipientsInvalid)[0]}`, {
                                    smooth: true,
                                    containerId: 'list-container',
                                    duration: 200
                                });
                            }

                            return {
                                ...(Object.keys(recipientsInvalid).length > 0 && {
                                        recipients: {...recipientsInvalid}
                                    }
                                ),
                            }
                        }}
                        onSubmit={handleImport}
                    >
                        {(
                            {
                                values,
                                errors,
                                handleSubmit,
                                setFieldValue,
                            }
                        ) => {

                            const removeRecipient = (i) => {
                                const recipients = values.recipients;
                                recipients.splice(i, 1);
                                setFieldValue('recipients', [...recipients]);
                            };

                            const handleRecipientInputChange = (e, i) => {
                                const recipients = values.recipients;
                                recipients[i] = e.target.value;
                                setFieldValue('recipients', [...recipients]);
                            };

                            const handleAddAnotherRecipient = () => {
                                const recipients = values.recipients;
                                recipients.push("");
                                setFieldValue('recipients', [...recipients]);
                                setScrollToBottom(true);
                            };

                            return (

                            <CSVReader
                                onUploadAccepted={(results) => {
                                    const recipients = [];
                                    for (let i = 0; i < results.data.length; i++) {
                                        for (let j = 0; j < results.data[i].length; j++) {
                                            if (validatePhoneNumber(results.data[i][j]) || validateEmail(results.data[i][j])) {
                                                recipients.push(results.data[i][j]);
                                            }
                                        }
                                    }
                                    onRecipientImport({recipients: {sms: [], email: []}})
                                    setFieldValue('recipients', recipients);
                                    setAccepted(true);
                                }}

                                onDragOver={(event) => {
                                    event.preventDefault();
                                    setZoneHover(true);
                                }}
                                onDragLeave={(event) => {
                                    event.preventDefault();
                                    setZoneHover(false);
                                }}
                            >

                                {
                                    ({
                                        getRootProps,
                                        acceptedFile,
                                        getRemoveFileProps,
                                    }) => {

                                        return (

                                            <form onSubmit={handleSubmit}>

                                                <Grid container spacing={2} justifyContent="center">

                                                    {step === 1 && (
                                                        <Grid item xs={12}>
                                                            <Typography>Upload a .csv file with one column that must include a phone number or email address. One recipient per row. You will be able to review your imported data after upload. (20 recipients max)</Typography>
                                                        </Grid>
                                                    )}

                                                    {step === 2 && (
                                                        <Grid item xs={12}>
                                                            <Typography>Please review your imported data. All recipients will receive the same merchant, gift wrapper and delivery date. (20 recipients max)</Typography>

                                                            {(values.recipients.length + cartCount) > 20 && (
                                                                <Alert className={classes.badFileAlert} severity="error">
                                                                    You have exceeded the number of recipients allowed (including items in cart, Max 20)
                                                                </Alert>
                                                            )}
                                                        </Grid>
                                                    )}

                                                    <Grid item xs={12} sm={12}>
                                                        <Grid container spacing={2} justifyContent="center">

                                                            {step === 1 && (
                                                                <>
                                                                    <Grid item xs={12} sm={5}>
                                                                        <Typography><small>Example:</small></Typography>
                                                                        <LazyImage width={185} height={284} src="https://d2kn7nb9ubajli.cloudfront.net/assets/recipient-import-list-sample.webp"/>
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={7}>
                                                                        <Grid container justifyContent="center">
                                                                            <Grid item xs={12}>
                                                                                <div className={classes.zoneContainer}>
                                                                                    <div
                                                                                        {...getRootProps()}
                                                                                        className={`${classes.zone} ${zoneHover && classes.zoneHover}`}
                                                                                    >
                                                                                        {(accepted && acceptedFile && values.recipients.length > 0) ? (
                                                                                            <div className={classes.file}>
                                                                                                <Typography component="span">{acceptedFile.name}</Typography>
                                                                                            </div>
                                                                                        ) : (
                                                                                            <Typography>Drop file here or <Link color="secondary" id="browse-file-button">choose a file</Link></Typography>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </Grid>
                                                                            <Grid item xs={12}>
                                                                                <Button disabled={!acceptedFile || values.recipients.length === 0} className={classes.continueToReviewFileButton} variant="contained" fullWidth={true} color="secondary" onClick={handleContinue}>
                                                                                    Continue
                                                                                </Button>

                                                                                {accepted && acceptedFile && values.recipients.length === 0 && (
                                                                                    <Alert className={classes.badFileAlert} severity="error">
                                                                                        The uploaded file did not find any valid data.
                                                                                    </Alert>
                                                                                )}
                                                                            </Grid>
                                                                            <Grid item xs={12}>
                                                                                <Typography gutterBottom={true} align="center"><small>Sending in bulk for a business or corporate account?<br/><Link href="/corporate" target="_blank" color="primary">Create an account</Link> or call <Link herf="tel:18555345222" color="primary">855-534-5222</Link> to get more information</small></Typography>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>
                                                                </>
                                                            )}

                                                            {step === 2 && (
                                                                <>
                                                                    <Grid item xs={12} sm={6} id="list-container" className={classes.listContainer}>
                                                                        {values.recipients.map((recipient, i) => (
                                                                            <Grid container key={i} className={`${classes.textFieldsRow}`} name={`import-recipients-modal-text-field-${i}`}>
                                                                                <Grid item xs>
                                                                                    <TextField
                                                                                        onChange={(e) => {handleRecipientInputChange(e, i)}}
                                                                                        value={recipient}
                                                                                        fullWidth={true}
                                                                                        label={"Phone number or email address"}
                                                                                        variant="filled"
                                                                                        className={classes.textFields}
                                                                                        {...(i === values.recipients.length - 1 && {
                                                                                            inputRef: lastInputRef
                                                                                        })}
                                                                                        error={errors.recipients && errors.recipients[i] && true}
                                                                                        helperText={errors.recipients && errors.recipients[i]}
                                                                                    />
                                                                                </Grid>
                                                                                <Grid item>
                                                                                    <IconButton className={classes.deleteButton} onClick={() => {removeRecipient(i)}}>
                                                                                        <DeleteOutlineIcon color="primary"/>
                                                                                    </IconButton>
                                                                                </Grid>
                                                                            </Grid>
                                                                        ))}
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={6}>
                                                                        <Grid container spacing={2}>
                                                                            {values.recipients.length > 0 && (
                                                                                <>
                                                                                    <Grid item xs={12}>
                                                                                        <Button disabled={(values.recipients.length + cartCount) > 20} fullWidth={true} onClick={handleSubmit} color="secondary" variant="contained">
                                                                                            Continue
                                                                                        </Button>
                                                                                        {(values.recipients.length + cartCount) > 20 && (
                                                                                            <Alert className={classes.miniMaxAlert} severity="error">
                                                                                                Max 20 GiftYas per order
                                                                                            </Alert>
                                                                                        )}
                                                                                    </Grid>
                                                                                    <Grid item xs={12}>
                                                                                        <Button fullWidth={true} onClick={handleAddAnotherRecipient} color="secondary" variant="outlined">
                                                                                            Add another recipient
                                                                                        </Button>
                                                                                    </Grid>
                                                                                </>
                                                                            )}
                                                                            <Grid item xs={12}>
                                                                                <Button fullWidth={true} color="secondary" onClick={(e) => {handleUploadNewFile({e, onClick: getRemoveFileProps().onClick})}}>Upload a new file</Button>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>
                                                                </>
                                                            )}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </form>

                                        )
                                    }
                                }
                            </CSVReader>
                        )}}
                    </Formik>
                </Grid>
            </Grid>

        </Modal>
        </>
    )
};

export default connect(
    () => ({}),
    {
        setModal
    }
)(ImportRecipientsFromCsvModal);